export default "__VITE_ASSET__D9SxMx3Z__"